/* eslint-disable no-console */
import { log, supabase } from ".";

export const getContratos = async ({ pais, orderBy = "created_at", ascending = false }) => {
  try {
    const filters = {};
    if (pais) filters.pais = pais;

    const data = await supabase.select("sales_contratos", {
      filters,
      orderBy,
      ascending,
    });

    return data || [];
  } catch (error) {
    log.error("getContratos", error);
    throw error;
  }
};
